"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ButtonAction = _interopRequireDefault(require("./ButtonAction"));

var _ButtonOption = _interopRequireDefault(require("./ButtonOption"));

var _ButtonGroup = _interopRequireDefault(require("@material-ui/core/ButtonGroup"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex"
  }
}));

const NavToolbar = ({
  className,
  toolbar = [],
  onEdit,
  onSave,
  onDelete,
  onRestore,
  onErase,
  onToggle
}) => {
  const classes = useStyles();

  if (!toolbar.length) {
    return false;
  }

  return _react.default.createElement("nav", {
    className: className || classes.root
  }, toolbar && toolbar.map((button, index) => {
    if (button.options) {
      return _react.default.createElement(_ButtonOption.default, _extends({}, button, {
        key: index
      }));
    }

    return _react.default.createElement(_ButtonAction.default, _extends({}, button, {
      key: index
    }));
  }));
};

var _default = NavToolbar;
exports.default = _default;
module.exports = exports.default;